import React from "react";
import { motion } from "framer-motion";
import { Bell, Newspaper, CalendarDays, Tag, QrCode, BarChart3, Users, Smartphone } from "lucide-react";
import { FEATURES } from "../data/content";

const ICONS = { Bell, Newspaper, CalendarDays, Tag, QrCode, BarChart3, Users, Smartphone };

export const Features = () => {
  return (
    <section id="funzionalita" className="py-20 sm:py-28" data-testid="features-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Funzionalità</span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Tutto quello che ti serve per comunicare
          </h2>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
            Uno strumento unico, semplice da usare, per restare in contatto con i tuoi clienti
            e farli tornare più spesso.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.07 }}
                className="group rounded-3xl bg-white p-7 border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-brand/5"
                data-testid={`feature-card-${i}`}
              >
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-light/30 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                  <Icon size={26} strokeWidth={2.5} />
                </span>
                <h3 className="mt-5 font-heading text-xl font-semibold text-brand-deep">{f.title}</h3>
                <p className="mt-2 font-body text-ink leading-relaxed">{f.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
